import Vue from 'vue'
import moment from 'moment'
import store from '@/store'
const _ = require("lodash")
Vue.filter('capitalize', function (value) {
	if (!value) return ''
	value = value.toString()
	let arr = value.split(" ")
	let capitalized_array = []
	arr.forEach((word) => {
		let capitalized = word.charAt(0).toUpperCase() + word.slice(1)
		capitalized_array.push(capitalized)
	})
	return capitalized_array.join(" ");
})


Vue.filter('str4', function (value) {
	return value.substring(0, 4)
})

Vue.filter('truncate', function (value, limit) {
	return value.substring(0, limit)
})

Vue.filter('tailing', function (value, tail) {
	return value + tail;
})

Vue.filter('time', function (value, is24HrFormat = false) {
	if (value) {
		const date = new Date(Date.parse(value));
		let hours = date.getHours();
		const min = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes()
		if (!is24HrFormat) {
			const time = hours > 12 ? 'AM' : 'PM';
			hours = hours % 12 || 12;
			return hours + ':' + min + ' ' + time
		}
		return hours + ':' + min
	}
})


Vue.filter('formatDate', function (value) {
	if (value) {
		return moment(String(value)).format('YYYY-MM-DD   LT')
	}
})
Vue.filter('formatDateOnly', function (value) {
	if (value) {
		return moment(String(value)).format('YYYY-MM-DD')
	}
})

Vue.filter('formatToTime', function (value) {
	if (value) {
		return moment(String(value)).format('hh:mm A')
	}
})

Vue.filter('date', function (value, fullDate = false) {
	value = String(value)
	const date = value.slice(8, 10).trim();
	const month = value.slice(4, 7).trim();
	const year = value.slice(11, 15);

	if (!fullDate) return date + ' ' + month;
	else return date + ' ' + month + ' ' + year;
})

Vue.filter('month', function (val, showYear = true) {
	val = String(val)

	const regx = /\w+\s(\w+)\s\d+\s(\d+)./;
	if (!showYear) {
		return regx.exec(val)[1];
	} else {
		return regx.exec(val)[1] + ' ' + regx.exec(val)[2];
	}

})

Vue.filter('csv', function (value) {
	return value.join(', ')
})

Vue.filter('filter_tags', function (value) {
	return value.replace(/<\/?[^>]+(>|$)/g, "")
})

Vue.filter('k_formatter', function (num) {
	return num > 999 ? (num / 1000).toFixed(1) + 'k' : num
})

Vue.filter('sound', function () {
	var audio = new Audio(require("@/assets/transaction.mp3"));
	audio.play();
})

Vue.filter('fixed2', function (value) {
	let val = (value / 1).toFixed(2).replace('.', '.')
	return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
})

Vue.filter('exchange_rate', function (value) {
	let exchange = store.getters["currency/selected_currency"];
	if (exchange.code == 'KIP') {
		return exchange.code + " " + _.round(value * exchange.rate).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}
	return exchange.code + " " + new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(_.round(value * exchange.rate, 4));
})

Vue.filter('exchange_rate_right', function (value) {
	let exchange = store.getters["currency/selected_currency"];
	if (exchange.code == 'KIP') {
		return _.round(value * exchange.rate).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " " + exchange.code;
	}
	return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(_.round(value * exchange.rate, 4)) + " " + exchange.code;
})






Vue.filter('commaNumber', function (value) {

	if ((value % 1) != 0) value = Number(value).toFixed(2)

	let exchange = store.getters["currency/selected_currency"];
	if (exchange.code == 'KIP') {
		return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",").split('.')[0];
	}
	// let val = ((value * exchange.rate) / 1).toFixed(2).replace(".", ".");
	return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(_.round(value, 4).toFixed(2));
})


Vue.filter('commaNumberRate', function (value, rate, code) {

	if ((value % 1) != 0) value = Number(value).toFixed(2)
	if (code == 'KIP') {
		if (value > -100 && value < 0) return 0
		return _.round(value * rate).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
	}


	return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(_.round(value * rate, 4))


	function addZeroes(num) {
		var value = Number(num);
		var res = num.split(".");
		if (res.length === 1 || res[1].length < 3) {
			value = value.toFixed(2);
		}
		return value;
	}
})

